const SustainabilityHub = ({ width, height, className, fillColor }: SustainabilityHubProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox='-2 -4 48 48'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      style={{ fill: 'none' }}
      d='M27.1811 23.5806L24.2429 30.674L20.7407 25.0852L27.1811 23.5806Z'
      stroke={fillColor}
      stroke-width='2.4'
      stroke-miterlimit='10'
      stroke-linecap='square'
    />
    <path
      style={{ fill: 'none' }}
      d='M25.7109 27.1293C27.545 27.8894 29.5749 28.0396 31.5009 27.5576C33.4269 27.0756 35.1468 25.9869 36.4066 24.4524C37.6664 22.918 38.3993 21.019 38.4971 19.036C38.5949 17.0531 38.0523 15.0912 36.9496 13.4403C35.8469 11.7893 34.2424 10.5367 32.3732 9.86754C30.504 9.19837 28.4692 9.14807 26.5692 9.72409C24.6692 10.3001 23.0049 11.4719 21.8219 13.0664C20.639 14.6609 20.0002 16.5935 19.9999 18.5789C19.9994 20.779 19.2147 22.9068 17.7868 24.5806C16.3589 26.2543 14.3812 27.3644 12.2086 27.7115C10.0361 28.0585 7.81095 27.62 5.93261 26.4744C4.05427 25.3289 2.6457 23.5514 1.95971 21.461C1.27372 19.3706 1.35522 17.1041 2.18958 15.0684C3.02395 13.0326 4.55655 11.3609 6.51232 10.3533C8.46808 9.34559 10.719 9.06796 12.861 9.5702C15.003 10.0724 16.8958 11.3217 18.1999 13.0936'
      stroke={fillColor}
      stroke-width='2.4'
      stroke-miterlimit='10'
    />
  </svg>
);

export type SustainabilityHubProps = {
  fillColor: string;
  className?: string;
  width: string | number;
  height: string | number;
};

SustainabilityHub.defaultProps = {
  width: 32,
  height: 32,
  fillColor: '#2A3745',
};

export default SustainabilityHub;
